import Badge from '../../elements/badge'
import React from 'react'

import { path } from '@uswitch/ev-utils/obj'

export const Badges = product => {
  const isPromoted = path(['comparables', 'promoted', 'value'], product)
  const isExclusive = path(['comparables', 'exclusive', 'value'], product)

  const promotedBadge = isPromoted ? <Badge key=''>{'Promoted'}</Badge> : <></>
  const exclusiveBadge = isExclusive ? <Badge key=''>{'Exclusive'}</Badge> : <></>

  return [promotedBadge, exclusiveBadge]
}

export default Badges
